const buildDealerContext = (currentRow = {}) => ({
  bac: currentRow?.bac || '',
  countryCd: currentRow?.countryCd || currentRow?.countryCode || 'US',
  categoryCd:
    currentRow?.programName ||
    currentRow?.programLabel ||
    currentRow?.categoryCd ||
    currentRow?.programCode ||
    '',
  programName: currentRow?.programName || currentRow?.programLabel || '',
  designation: currentRow?.designation || '',
  status:
    currentRow?.productSelectionStatusCd ||
    currentRow?.programSelectionStatusCd ||
    currentRow?.status ||
    '',
  brandCodes: currentRow?.brandCodes || [],
  lastUpdatedBy: currentRow?.lastUpdatedBy || currentRow?.updatedBy || '',
  vendors: currentRow?.vendors || [],
});

export default buildDealerContext;
